import React, { useState } from "react";
import styles from "./OtpScreen.module.css";
import img from "../../../Images/LoginImages/Mask group (2).png";

const ForgotPassword = () => {
  const [otp, setOtp] = useState(["", "", "", ""]);

  const handleChange = (index, value) => {
    const updatedOtp = [...otp];

    // Handle deletion and move focus to the previous input
    if (value === "" && otp[index] !== "" && index > 0) {
      updatedOtp[index] = "";
      setOtp(updatedOtp);

      const prevInput = document.getElementById(`otp-${index - 1}`);
      if (prevInput) prevInput.focus();
      return;
    }

    // Ensure the input is numeric
    if (isNaN(value) || value.length > 1) return;

    // Update the OTP array and move to the next input
    updatedOtp[index] = value;
    setOtp(updatedOtp);

    if (value && index < otp.length - 1) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      if (nextInput) nextInput.focus();
    }
  };

  const handleContinue = (e) => {
    e.preventDefault();
    console.log("Entered OTP:", otp.join(""));
  };

  return (
    <div className={styles.container}>
      {/* Left Section: Image */}
      <div className={styles.leftSection}>
        <img src={img} alt="Secure Access" className={styles.image} />
      </div>

      {/* Right Section: Forgot Password Form */}
      <div className={styles.rightSection}>
        <div className={styles.formWrapper}>
          <h2 className={styles.title}>Forgot Password?</h2>
          <p className={styles.subtitle}>
            No warrior will, send you reset instructions.
          </p>

          {/* OTP Inputs */}
          <div className={styles.inputGroup}>
            {otp.map((digit, index) => (
              <input
                key={index}
                id={`otp-${index}`}
                type="text"
                maxLength="1"
                value={digit}
                onChange={(e) => handleChange(index, e.target.value)}
                className={styles.input}
                onKeyDown={(e) => {
                  if (e.key === "Backspace" && otp[index] === "") {
                    const prevInput = document.getElementById(`otp-${index - 1}`);
                    if (prevInput) prevInput.focus();
                  }
                }}
              />
            ))}
          </div>

          {/* Continue Button */}
          <button onClick={handleContinue} className={styles.button}>
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
